import { wirePerfDebug } from './controllers/wirePerfDebug.js';
import {
  createStressMinions,
  createStressProjectiles
} from '../application/perf/stressSpawn.js';

function heapMbFromPerformance() {
  const mem = typeof performance !== 'undefined' ? performance.memory : null;
  return mem ? mem.usedJSHeapSize / (1024 * 1024) : null;
}

function makeSpawnMinions({ addMinionsToScene, championEntity }) {
  return (count) => {
    const list = createStressMinions({
      count,
      team: 'red',
      origin: { x: (championEntity?.x || 0) + 3, z: championEntity?.z || 0 }
    });
    if (typeof addMinionsToScene === 'function') addMinionsToScene(list);
    return list.length;
  };
}

function makeSpawnProjectiles({
  activeProjectiles, championEntity, dummyEntity, MeshFactory, scene
}) {
  return (count) => {
    const list = createStressProjectiles({
      count, source: championEntity, target: dummyEntity
    });
    for (const domain of list) {
      const mesh = MeshFactory?.createFrostArrowMesh
        ? MeshFactory.createFrostArrowMesh(false)
        : null;
      if (mesh && scene) scene.add(mesh);
      activeProjectiles.push({ domain, mesh });
    }
    return list.length;
  };
}

/**
 * bootPerfHarness — Live FPS / stress hooks for agent smoke (TM-06).
 */
export function bootPerfHarness({
  renderer,
  scene,
  activeMinions,
  activeProjectiles,
  addMinionsToScene,
  championEntity,
  dummyEntity,
  MeshFactory,
  globalObj = typeof window !== 'undefined' ? window : null
} = {}) {
  return wirePerfDebug({
    globalObj,
    getRendererInfo: () => renderer?.info || null,
    getCounts: () => ({
      minions: activeMinions.length,
      projectiles: activeProjectiles.length
    }),
    getHeapMb: heapMbFromPerformance,
    spawnMinions: makeSpawnMinions({ addMinionsToScene, championEntity }),
    spawnProjectiles: makeSpawnProjectiles({
      activeProjectiles, championEntity, dummyEntity, MeshFactory, scene
    }),
    castStorm: () => (globalObj?.__debugCastKit
      ? globalObj.__debugCastKit()
      : { ok: false, reason: 'no_cast_kit' })
  });
}
